<script>
    import {I_COMPANY} from "../../../../../lib/datatypes";
    import {navigateTo, PAGE_ID} from "../stores/router";
    import {selectCompany} from "../stores/misc";
    import {companies} from "../stores/companies";
    import Label from "./Label.svelte";

    export let related_companies = [];
    export let return_page_id = PAGE_ID.DASHBOARD;

</script>


{#if related_companies.length > 0}
    <ul role="list" class="mt-2 divide-y divide-gray-200 rounded-md border border-gray-200">
        {#each related_companies as company (company.id)}
            <li>
                <a on:click|preventDefault={() => {
                                    selectCompany(company.id);
                                    navigateTo(PAGE_ID.VIEW_COMPANY, return_page_id);
                                }} href="/" class="flex items-center justify-between py-3 pl-3 pr-4 text-sm">
                    <div class="flex w-0 flex-1 items-center">
                        <Label type="company"></Label>
                        <span class="ml-2 w-0 flex-1 truncate">{$companies.lookup[company.id][I_COMPANY.NAME]}</span>
                    </div>
                </a>
            </li>
        {/each}
    </ul>
{/if}


<style></style>